import './style.scss';

import { ReactComponent as InstagramIcon } from "assets/icons/social/instagram.svg";
import { ReactComponent as LinkedinIcon } from "assets/icons/social/linkedin.svg";
import { ReactComponent as TwitterIcon } from "assets/icons/social/twitter.svg";

const ContactPage = () => (
  <section className="contact-page">
    <div className="contact-block">
      <p className="contact-block__title">Email</p>
      <a href="mailto:contact@damonnam.com" className="contact-block__text">contact@damon.ae</a>
    </div>
    <div className="contact-block contact-block_follow">
      <p className="contact-block__title">Follow</p>
      <div className="contact-block__social-row">
        <a className="contact-block__social-icon-wrapper" href="https://instagram.com/damon" target="_blank" rel="noreferrer">
          <InstagramIcon className="contact-block__social-icon"/>
        </a>
        <a className="contact-block__social-icon-wrapper" href="https://linkedin.com/in/damonnam" target="_blank" rel="noreferrer">
          <LinkedinIcon className="contact-block__social-icon"/>
        </a>
        <a className="contact-block__social-icon-wrapper" href="https://x.com/damonnam" target="_blank" rel="noreferrer">
          <TwitterIcon className="contact-block__social-icon"/>
        </a>
      </div>
    </div>
  </section>
);

export default ContactPage;
